module.exports = __webpack_public_path__ + "img/87.35368c2b.png";